/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventDto } from '../../models/harvest-event-dto';

export interface GetFacilityGroupEvents$Params {
  facilityGroupId: number;
}

export function getFacilityGroupEvents(http: HttpClient, rootUrl: string, params: GetFacilityGroupEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventDto>>> {
  const rb = new RequestBuilder(rootUrl, getFacilityGroupEvents.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestEventDto>>;
    })
  );
}

getFacilityGroupEvents.PATH = '/api/harvests/facilityGroup/{facilityGroupId}/events';
